// extracted by mini-css-extract-plugin
export default {"root":"SupportContactFormHeader_root__1xtyZ","placeHolderShimmer":"SupportContactFormHeader_placeHolderShimmer__HB67a"};